import { Link } from "react-router-dom";

export const LogoIcon = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="5" width="90" height="90" rx="16" fill="#131b2e"/>
    <rect d="M25 22 h14 v58 h-14z" />
    <path d="M28 20 L28 50 L42 50 L42 82 L28 82 L28 50" fill="#2979FF"/>
    <path d="M42 50 L60 50 L60 64 L42 64 Z" fill="#2979FF"/>
    <path d="M28 20 L72 20 L72 35 L42 35 L42 50 L62 50 L62 35 L42 35 L42 20 L28 20" fill="#E53935"/>
    <path d="M42 35 L62 35 L62 50 L42 50 Z" fill="#E53935"/>
  </svg>
);

export const Logo = ({ variant = "default" }) => (
  <Link to="/" className="inline-flex items-center gap-3 group" data-testid="logo-link">
    <LogoIcon size={42} />
    <div>
      <div className="flex items-baseline">
        <span className="text-xl font-extrabold text-slate-900 dark:text-white tracking-tight">Futures</span>
        <span className="text-xl font-extrabold text-[#E53935] tracking-tight">Fury</span>
      </div>
      <p className="text-[10px] text-[#4CAF50] tracking-[0.2em] uppercase font-bold">Compare Smart. Fund Strong.</p>
    </div>
  </Link>
);
